import type { SchedulerProcessedDate, TemporalSupportedObject } from '../models';
import type { Adapter } from '../use-adapter';
import { getDateKey } from '../internals/utils/date-utils';

/**
 * Creates a processed date object from a date object.
 */
export function processDate(
  date: TemporalSupportedObject,
  adapter: Adapter,
): SchedulerProcessedDate {
  const hours = adapter.getHours(date);
  const minutes = adapter.getMinutes(date);

  return {
    value: date,
    key: getDateKey(date, adapter),
    timestamp: adapter.getTime(date),
    minutesInDay: hours * 60 + minutes,
  };
}
